import React from 'react';
import { useLocale } from './../special/LanguageProvider';
import Spinner from './../../shared/jsx/elements/spinner/index';
import MessageBox from './../messages/MessageBox';
import ReactTooltip  from 'react-tooltip';


const ListTable = ( { children, colsettings= [], columns = [], headers = [], isLoading = false, list = null, error = null}) => {
  const {t} = useLocale();
    
  return (
      <div>
        <ReactTooltip/>
        {isLoading &&             
            <div className="grid box" style={{ height: '70px', position: 'relative' }}>
                <Spinner relCenter />
            </div>}
        
        {!isLoading && list && (                            
            <div className="table-wrap">
                <table className="table advanced hover ">
                    <colgroup>
                        {colsettings.map((colset, colsetIndex) => 
                            <col width={colset} key={colsetIndex} />                            
                        )}                        
                    </colgroup>
            <thead>
            <tr>
                {headers.map((header, headerIndex) => 
                    <th className="no-right-border no-left-border" key={headerIndex}>{header}</th>                                         
                )}                        
            </tr>
            </thead>
                <tbody>  
                    {children}
                    {list.map((item, index) =>             
                        <tr key={index}>
                            {columns.map((col, colIndex) =>
                                <td className="no-right-border no-left-border" key={index+"-"+colIndex}>{col(item)}</td>       
                            )}
                        </tr>
                    )}  
                    {!error && list.length == 0 && (
                        <tr>
                            <td colSpan={headers.length} className="no-right-border no-left-border text-center">{t("Engar færslur")}</td>   
                        </tr>
                    )}

                    {error && (
                    <tr>
                        <td colSpan={headers.length} className="no-right-border no-left-border text-center">
                            <MessageBox messageHeader={error.error.message} messageBody={error.error.detail} messageType="error" />
                        </td>   
                    </tr>)}
                             

                </tbody>
            </table>
            </div>
        )}        
      </div>      
  );
}


export default ListTable;